<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  mounted() {},
  created() {
    if (sessionStorage.user) {
      this.setUser(JSON.parse(sessionStorage.user));
    }
  },
  methods: {
    ...mapActions(["setUser", "SetLang"])
  },
  computed: mapGetters({
    user: "user"
  })
};
</script>

<style lang="scss">
body,
html {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  color: #383838;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.primary {
  background: $theme-color !important;
  padding: 9px 26px !important;
}

//表格样式重写
.table-box {
  .ivu-table-header {
    .table-header-col {
      height: 57px !important;
      background: #fff !important;
    }
  }
  .ivu-table {
    &:before {
      height: 0 !important;
      background-color: none !important;
    }
  }
  .ivu-table:after {
    height: 0 !important;
    background-color: none !important;
  }
  .ivu-table-wrapper {
    border: none !important;
  }
  .ivu-table-tbody {
    .table-header-col {
      height: 80px !important;
      .ivu-btn {
        margin-left: 10px;
        :nth-child(1) {
          margin-left: 0;
        }
      }
    }
  }
}

//页码
.t-right {
  margin-top: 20px;
  float: right;
  .ivu-page-prev {
    border: 0 !important;
  }
  .ivu-page-next a,
  .ivu-page-prev a {
  }
  .ivu-page-item-active {
    background: $theme-color;
    a {
      color: #fff;
    }
  }
}
//model
.ivu-modal-body {
  padding: 0 !important;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

//表单
.from {
  .item {
    .ivu-input-large {
      height: 44px;
    }
    .ivu-icon {
      line-height: 44px;
    }
  }
}

.hoverShow:hover {
  box-shadow: 0 0 8px #ccc;
}
.link-btn-hover:hover{
  background-color: rgba(0,0,0,.3) !important;
}

//登录页面样式重写
.logo-tabs{
  .ivu-tabs-bar{
    border-bottom: none;
    .ivu-tabs-nav-container{
      font-size: 18px !important;
    }
    .ivu-tabs-tab{
      color: #A0ACC2;
      padding: 8px 0;
      // margin-right: 30px;
    }
    .ivu-tabs-tab:hover{
      color: #A0ACC2;
    }
    .ivu-tabs-tab-focused{
      font-weight: bold;
      color: #3a4150;
    }
  }
}
//登录页面轮播组件样式重写
.ivu-carousel{
  width: 100%;
  height: 100%;
}
</style>
